import React, { useState } from "react";
import styled from "styled-components";

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// Styled components for the dropdown
const Container = styled.div`
  font-family: Arial, sans-serif;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
`;

const Label = styled.label`
  display: block;
  padding-bottom: 8px;
  font-size: 16px;
  color: #333333;
  text-align: left;
`;

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f4f4;
  padding: 20px;
  height: 60px;
  width: 100%;
  border: 1px solid #cccccc33;
  box-shadow: 0px 4px 8px rgba(91, 135, 239, 0.3); 
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: background-color 0.2s ease;
`;

const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  transition: opacity 0.3s ease, visibility 0s linear 0.3s;
`;

const DropdownItem = styled.li`
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  text-align: left;
  color: #666;
  transition: background-color 0.2s ease;

  &:hover {
    font-weight: bold;
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    color: #333;
  `}
`;

const BaseListBox = ({ options, value, isSelected, title = '', placeholder = '', onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSelectedValue(option);
  };

  return (
    <Container>
      <Label>{title}</Label>
      <SelectWrapper>
        <DropdownButton onClick={() => setIsOpen(!isOpen)}>
          {isSelected && selectedValue ? selectedValue?.label : placeholder}
          <span>{isOpen ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}</span>
        </DropdownButton>
        <DropdownList isOpen={isOpen}>
          {options?.map((option) => (
            <DropdownItem
              key={option.value}
              onClick={() => handleSelect(option)}
              isSelected={option.value === selectedValue?.value}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownList>
      </SelectWrapper>
    </Container>
  );
};

export default BaseListBox;
